module.exports = __webpack_public_path__ + "static/institutionLogoUniversityPlymouth-3c129c5b7ed00a3886f2c1e872f10459.png";